"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMerge = deepMerge;
exports.isObject = isObject;
exports.omit = omit;
exports.pick = pick;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function isObject(item) {
  return item && (0, _typeof2.default)(item) === 'object' && !Array.isArray(item);
}
function pick(object) {
  if (!isObject(object)) {
    throw new Error('`object` param must be an object.');
  }
  var result = {};
  for (var _len = arguments.length, keysToGet = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToGet[_key - 1] = arguments[_key];
  }
  keysToGet.forEach(function (key) {
    if (typeof object[key] !== 'undefined') {
      result[key] = object[key];
    }
  });
  return result;
}
function omit(object) {
  if (!isObject(object)) {
    throw new Error('`object` param must be an object.');
  }
  var result = _objectSpread({}, object);
  for (var _len2 = arguments.length, keysToOmit = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keysToOmit[_key2 - 1] = arguments[_key2];
  }
  keysToOmit.forEach(function (key) {
    return delete result[key];
  });
  return result;
}
function deepMerge(target) {
  for (var _len3 = arguments.length, sources = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sources[_key3 - 1] = arguments[_key3];
  }
  if (!sources.length) {
    return target;
  }
  var source = sources.shift();
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, (0, _defineProperty2.default)({}, key, {}));
        }
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, (0, _defineProperty2.default)({}, key, source[key]));
      }
    });
  }
  return deepMerge.apply(void 0, [target].concat(sources));
}
//# sourceMappingURL=objects.js.map